import { render, staticRenderFns } from "./salary-existcompany.vue?vue&type=template&id=efd42e08&scoped=true&"
import script from "./salary-existcompany.vue?vue&type=script&lang=js&"
export * from "./salary-existcompany.vue?vue&type=script&lang=js&"
import style0 from "./salary-existcompany.vue?vue&type=style&index=0&id=efd42e08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd42e08",
  null
  
)

export default component.exports